import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { LocationPinIcon20Light } from '@skbkontur/icons/icons/LocationPinIcon';
import { Button } from '@skbkontur/react-ui';
import { text as validationText, ValidationWrapper } from '@skbkontur/react-ui-validations';
import classes from './AddressButton.module.css';
export const AddressButton = forwardRef(({ onClick, validationInfo, icon = _jsx(LocationPinIcon20Light, {}), text = 'Указать', 'data-tid': dataTid }, ref) => {
    return (_jsx(ValidationWrapper, { validationInfo: validationInfo, renderMessage: validationText('right'), children: _jsx(Button, { ref: ref, use: "text", onClick: onClick, className: classes.addressButton, icon: icon, "data-tid": dataTid, children: text }) }));
});
AddressButton.displayName = 'AddressButton';
